module.exports = __webpack_public_path__ + "static/media/background-day.d447531b.png";